function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-form/dist/index.module.css';
function Form(props) {
  const {
    layout,
    children,
    className,
    inlineStyle,
    ...restProps
  } = props;
  const layoutClasses = classNames({
    [styles['sib-form']]: true,
    [styles['sib-form-row']]: layout === 'horizontal',
    [styles['sib-form-column']]: layout === 'vertical',
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("form", _extends({
    className: layoutClasses,
    style: inlineStyle
  }, restProps), children);
}
Form.defaultProps = {
  className: '',
  inlineStyle: {},
  layout: 'vertical'
};
Form.propTypes = {
  layout: PropTypes.string,
  className: PropTypes.string,
  inlineStyle: PropTypes.object,
  children: PropTypes.node.isRequired
};
function FormItem(props) {
  const {
    children,
    className,
    inlineStyle
  } = props;
  const formGroupClasses = classNames({
    [styles['sib-form--item']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: formGroupClasses,
    style: inlineStyle
  }, children);
}
FormItem.defaultProps = {
  className: '',
  layout: 'vertical',
  inlineStyle: {}
};
FormItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  inlineStyle: PropTypes.object
};
Form.displayName = 'Form';
export default Object.assign(Form, {
  Item: FormItem
});